import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { Paciente } from '../paciente';
import { PacienteService } from '../paciente.service';

@Component({
  selector: 'app-paciente-maintenance',
  templateUrl: './paciente-maintenance.component.html',
  styleUrls: ['./paciente-maintenance.component.css']
})
export class PacienteMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  paciente: Paciente;

  pacienteTitular: Paciente;

  formularioPaciente: FormGroup;

  tituloCrud: string = '';

  dependentes: Paciente[];

  numeroDaLinhaSelecionadaNaTabelaDeDependente: number = -1;

  onClickNaTabelaDeDependente: any;

  constructor(private pacienteService: PacienteService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.pacienteTitular = history.state.pacienteTitular;

    if (this.pacienteTitular) {
      this.paciente = Object.assign(new Paciente(), this.pacienteTitular);
    } else {
      this.paciente = new Paciente();
    }

    this.formularioPaciente = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(6)]],
      cpf: ['', [Validators.required, CpfCnpjValidator.validate]],
      dataNascimento: ['', [Validators.required]],
      foneResidencial: [''],
      foneCelular: [''],
      dependentes: [[]],
      dependenteAtivo: [false],
      dependentesExcluidos: [[]],
    });

    this.dependentes = [];

    this.onClickNaTabelaDeDependente = function (index: number) {
      this.numeroDaLinhaSelecionadaNaTabelaDeDependente = index;
    }
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Paciente';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Paciente';
      }
    } else {
      this.tituloCrud = 'Criar Paciente';
    }

    this.configurarForm();
  }

  save() {

    this.paciente = Object.assign(new Paciente(), this.formularioPaciente.value);

    if (this.paciente.foneCelular || this.paciente.foneResidencial) {

      if (this.isNew()) {
        this.pacienteService
          .criar(this.paciente).subscribe(data => {
            // console.log(data)

            this.gotoList();
          }, error => {
            console.log(error);
          });
      } else {
        this.pacienteService.atualizar(this.paciente)
          .subscribe(data => {
            // console.log(data); 

            this.gotoList();
          }, error => {
            console.log(error);
          });
      }
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Preencha pelo menos um número de telefone!'
        }
      });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/pacientes'], {
      state: {
        filtroPaciente: history.state.filtroPaciente,
      }
    });
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioPaciente.controls;
  }

  configurarForm(): void {
    if (this.pacienteTitular) {

      this.configurarAtributosPaciente();

    } else if (!this.isNew()) {
      this.pacienteService.procurarPorId(this.id)
        .subscribe(data => {
          // console.log(data)

          this.paciente = Object.assign(new Paciente(), data);

          this.configurarAtributosPaciente();

        }, error => {
          console.log(error);
        });
    } else {
      this.formularioPaciente.setValue({
        id: 0,
        nome: '',
        cpf: '',
        dataNascimento: '',
        foneResidencial: '',
        foneCelular: '',
        dependentes: [],
        dependenteAtivo: false,
        dependentesExcluidos: [],
      });
    }
  }

  configurarAtributosPaciente(): void {
    if (!this.paciente.cpf) {
      this.paciente.cpf = '';
    }

    this.formularioPaciente.setValue(this.paciente);

    if (this.paciente.dependentes) {
      this.dependentes = this.paciente.dependentes;
    } else {
      this.dependentes = [];
    }

    this.formularioPaciente.controls.cpf.patchValue(cpf.format(this.paciente.cpf));

    this.cd.detectChanges();

    if (this.isUpdate == 'N') {
      this.formularioPaciente.disable();
    }
  }

  removerDependenteSelecionado(): void {
    if (this.numeroDaLinhaSelecionadaNaTabelaDeDependente != -1 && this.dependentes) {
      this.dependentes.splice(this.numeroDaLinhaSelecionadaNaTabelaDeDependente, 1)
    }
  }

  atualizarAtributosDoFormNaEntidadePaciente(): void {
    this.paciente = this.formularioPaciente.value;
  }

  navegarParaTelaDeCadastroDeDependente(): void {

    this.atualizarAtributosDoFormNaEntidadePaciente();

    this.router.navigate(['/cadastrarDependente'], {
      state: {
        pacienteTitular: this.paciente,
        id: this.id,
        isUpdate: this.isUpdate,
        filtroPaciente: history.state.filtroPaciente,
      }
    });
  }

}
